const { dataLayerListener } = require('./data-layer.cjs');
const { getGTMId, gtm } = require('./gtm.cjs');
const { alfaPartners, antiFraud } = require('./partners.cjs');
const { platformIdReady } = require('./platform-id-ready.cjs');
const { ytm, ytmCookie, ytmNoScript, ytmSendEvent, ytmSendUserParams } = require('./ytm.cjs');
const { sentry } = require('./sentry.cjs');

const getCounters = (url, data, { clientEnv }) => {
    const { CUSTOM_YTM_ID, ENABLE_COUNTERS } = process.env;
    const {
        collectorData: { host }
    } = data;
    const gtmId = getGTMId(host);
    const isCountersEnabled = ENABLE_COUNTERS === 'true';
    const enableYtm = isCountersEnabled && CUSTOM_YTM_ID;
    const ytmScripts = [ytmNoScript, ytmCookie, dataLayerListener, ytmSendUserParams, ytmSendEvent];
    const headGTM = isCountersEnabled ? gtm(gtmId) : '';
    const headYTM = enableYtm ? ytm(url) : '';
    const bodyYTM = enableYtm ? ytmScripts.join('') : '';

    return {
        headCounters: [platformIdReady, headGTM, headYTM],
        bodyCounters: [
            bodyYTM,
            isCountersEnabled ? alfaPartners(url) : '',
            isCountersEnabled ? antiFraud : ''
        ],
        endBodyCounters: [
            clientEnv.SENTRY_DSN
                ? sentry({
                      cityInfo: data.cityInfo,
                      sentryDsn: clientEnv.SENTRY_DSN,
                      sentrySampleRate: parseFloat(clientEnv.SENTRY_SAMPLE_RATE || '0.75', 10)
                  })
                : ''
        ]
    };
};

module.exports = { getCounters };
